export default () => ({
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    accessLevels: [],
    // modules: [],
    // employeeHere: [],
    listEmployees: [],
    permissions: [],
});
